/* Street Garms SG-044 — PDP reassurance order experiment.
 * Existing reassurance wording and styling are unchanged; this asset also adds a worldwide delivery row.
 *
 * Default/no parameter = current control (authentication first).
 * Preview/test URLs on a product page:
 *   ?sg_reassurance=control
 *   ?sg_reassurance=returns_first
 *   ?sg_reassurance=delivery_first
 *   ?sg_reassurance=auto   (1/3 session-level random assignment)
 *
 * Tracking hooks are dataLayer + CustomEvent only; this asset makes no third-party requests.
 */
(function () {
  'use strict';

  var EXPERIMENT = 'SG-044';
  var PARAM = 'sg_reassurance';
  var SESSION_KEY = 'sg044ReassuranceVariant';
  var VALID = ['control', 'returns_first', 'delivery_first'];
  var ORDERS = {
    // Existing Street Garms order = authentication first.
    control: ['authentication', 'returns', 'shipping', 'international', 'estimate'],
    // Returns/low-risk purchase message first.
    returns_first: ['returns', 'authentication', 'shipping', 'international', 'estimate'],
    // Delivery proposition first, keeping the two delivery rows adjacent.
    delivery_first: ['shipping', 'international', 'estimate', 'authentication', 'returns']
  };

  function normalise(value) {
    value = String(value || '').toLowerCase().trim().replace(/-/g, '_');
    if (value === 'a' || value === 'control' || value === 'current' || value === 'authentication_first' || value === 'auth_first') return 'control';
    if (value === 'b' || value === 'returns_first' || value === 'return_first' || value === 'returns') return 'returns_first';
    if (value === 'c' || value === 'delivery_first' || value === 'shipping_first' || value === 'delivery') return 'delivery_first';
    if (value === 'auto' || value === 'random') return 'auto';
    return '';
  }

  function randomVariant() {
    return VALID[Math.floor(Math.random() * VALID.length)];
  }

  function getVariant() {
    var requested = '';
    try { requested = normalise(new URL(window.location.href).searchParams.get(PARAM)); } catch (e) {}

    if (requested === 'auto') {
      try {
        var stored = normalise(window.sessionStorage.getItem(SESSION_KEY));
        if (VALID.indexOf(stored) !== -1) return stored;
        var assigned = randomVariant();
        window.sessionStorage.setItem(SESSION_KEY, assigned);
        return assigned;
      } catch (e) {
        return randomVariant();
      }
    }

    if (VALID.indexOf(requested) !== -1) {
      try { window.sessionStorage.setItem(SESSION_KEY, requested); } catch (e) {}
      return requested;
    }

    // Do not change the normal site unless an experiment parameter is supplied.
    return 'control';
  }

  function push(eventName, variant, extra) {
    var payload = {
      event: eventName,
      sg_experiment_id: EXPERIMENT,
      sg_reassurance_variant: variant
    };
    if (extra) Object.keys(extra).forEach(function (key) { payload[key] = extra[key]; });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function dispatch(eventName, variant, extra) {
    try {
      window.dispatchEvent(new CustomEvent(eventName, {
        detail: Object.assign({ experiment: EXPERIMENT, variant: variant }, extra || {})
      }));
    } catch (e) {}
  }

  function currentProduct() {
    var body = document.body;
    return {
      product_path: window.location.pathname || '',
      product_id: body ? (body.getAttribute('data-product-id') || '') : ''
    };
  }

  function ensureWorldwideDeliveryRow(container) {
    if (container.querySelector('[data-sg044-reassurance-row="international"]')) return;

    var shippingRow = container.querySelector('[data-sg044-reassurance-row="shipping"]');
    if (!shippingRow || !shippingRow.parentNode) return;

    var internationalRow = shippingRow.cloneNode(true);
    internationalRow.setAttribute('data-sg044-reassurance-row', 'international');
    internationalRow.setAttribute('href', '/pages/shipping-times');

    var heading = internationalRow.querySelector('.sg-pdp-trust-v11__copy > strong');
    var text = internationalRow.querySelector('.sg-pdp-trust-v11__copy > span');

    if (heading) heading.textContent = '£15 worldwide delivery';
    if (text) text.textContent = 'Flat rate. Usually 7–14 working days after dispatch.';

    shippingRow.parentNode.insertBefore(internationalRow, shippingRow.nextSibling);
  }

  function reorder(container, variant) {
    var rowMap = {};
    container.querySelectorAll('[data-sg044-reassurance-row]').forEach(function (row) {
      rowMap[row.getAttribute('data-sg044-reassurance-row')] = row;
    });

    var order = ORDERS[variant] || ORDERS.control;
    order.forEach(function (key) {
      if (rowMap[key]) container.appendChild(rowMap[key]);
    });

    container.setAttribute('data-sg044-variant', variant);
  }

  function bindLinkClicks(container, variant) {
    container.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[data-sg044-reassurance-row]');
      if (!link || !container.contains(link)) return;
      var row = link.getAttribute('data-sg044-reassurance-row') || '';
      var extra = currentProduct();
      extra.sg_reassurance_row = row;
      push('sg044_reassurance_link_click', variant, extra);
      dispatch('sg:reassurance-link-click', variant, extra);
    }, true);
  }

  function bindAddToCart(variant) {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      var extra = currentProduct();
      push('sg044_pdp_add_to_cart', variant, extra);
      dispatch('sg:pdp-add-to-cart', variant, extra);
    }, true);
  }

  function apply() {
    var container = document.querySelector('[data-sg044-reassurance]');
    if (!container) return;

    var variant = getVariant();
    ensureWorldwideDeliveryRow(container);
    document.documentElement.setAttribute('data-sg-reassurance-experiment', EXPERIMENT);
    document.documentElement.setAttribute('data-sg-reassurance-variant', variant);

    reorder(container, variant);
    bindLinkClicks(container, variant);
    bindAddToCart(variant);

    var extra = currentProduct();
    push('sg044_reassurance_exposure', variant, extra);
    dispatch('sg:reassurance-exposure', variant, extra);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }
})();
